import { store } from '@/store/index'
import i18n from '@/plugins/i18n'
import { validateMaterial } from '@/api/product'

export function isStockAvailable(stock_qty, hold_qty, qty, is_out_stock) {
  return Number(stock_qty) - Number(hold_qty) >= Number(qty) && !is_out_stock
}

export function showError(name) {
  Object.assign(store.state, {
    show_error: true,
    error_message: i18n.t('v2.stock_is_not_enough', { data: name }),
    error_type: 402
  })
  return true
}

export function parseNote(note) {
  const arrNote = note.split(',')
  if (arrNote[0] === 'TAKE AWAY') {
    arrNote.splice(0, 1)
    return [true, arrNote.join(',').trim()]
  } else {
    return [false, arrNote.join(',').trim()]
  }
}

export function checkStockMaterials(item, materials) {
  let is_available = true
  for (const material of materials) {
    const name = material.material_product_variant_id ? material.product_variant_name : material.product_name
    if (material.product_out_stock || (Number(material.track_inventory) === 1 && store.state.selected_outlet.pos_disallow_sell_no_stock)) {
      is_available = isStockAvailable(material.product_stock_qty, material.product_hold_qty, (material.qty * item.qty), material.product_out_stock)
      if (!is_available) {
        showError(name)
        break
      }
    }
  }
  return is_available
}

export function evaluateComboStock(item_combo, qty) {
  const name = item_combo.item_variant_name ? `${item_combo.item_name} - ${item_combo.item_variant_name}` : item_combo.item_name
  return (item_combo.track_inventory && !isStockAvailable(item_combo.stock_qty, item_combo.hold_qty, qty, item_combo.is_out_stock)) ? showError(name) : item_combo.is_out_stock && showError(name)
}

export function evaluateSingleItemStock(item, materials) {
  const name = item.item_variant_name ? `${item.item_name} - ${item.item_variant_name}` : item.item_name
  const { pos_disallow_sell_no_stock } = store.state.selected_outlet
  if (item.track_inventory && pos_disallow_sell_no_stock) {
    return !isStockAvailable(item.stock_qty, item.hold_qty, item.qty, item.is_out_stock) && showError(name)
  } else if (!item.track_inventory && pos_disallow_sell_no_stock) {
    return item.product_has_material ? !checkStockMaterials(item, materials) : false
  } else {
    return item.is_out_stock && showError(name)
  }
}

export async function checkInventory(item, materials) {
  if (item.product_combo_id) {
    return item.item_product_combo.some(item_combo =>
      evaluateComboStock(item_combo, item.qty)
    )
  } else {
    return evaluateSingleItemStock(item, materials)
  }
}

export function prepareCartItem(item, materials) {
  const list_item_combo = item.item_product_combo ? item.item_product_combo.map(item_combo => ({
    disabled: false,
    hold_qty: item_combo.hold_qty,
    id: item_combo.product_combo_parent_id || item_combo.product_combo_item_id,
    children_id: item_combo.product_combo_parent_id ? item_combo.product_combo_item_id : '',
    image: item_combo.image,
    is_out_stock: item_combo.is_out_stock,
    name: item_combo.product_variant_id === 0 ? item_combo.item_name : `${item_combo.item_name} (${item_combo.item_variant_name})`,
    published: item_combo.published,
    qty: item_combo.qty,
    stock_qty: item_combo.stock_qty,
    track_inventory: item_combo.track_inventory,
    variant_id: item_combo.product_variant_id || ''
  })) : []
  const [product_is_takeaway, product_note] = parseNote(item.note)
  const product_addon = item.addon.map(addon => ({
    product_addon_id: addon.product_addon_id,
    product_addon_name: addon.name
  }))

  return {
    addons: product_addon,
    has_material: item.product_combo_id ? 0 : item.product_has_material,
    hold_qty: item.hold_qty || 0,
    is_out_stock: item.is_out_stock,
    is_takeaway: product_is_takeaway,
    klasifikasi_id: item.product_group_id || null,
    materials: item.product_combo_id ? [] : materials,
    name: item.item_name,
    non_service_charge: item.non_service_charge || 0,
    non_taxable: item.non_taxable || 0,
    note: product_note,
    product_combo_id: item.product_combo_id || null,
    product_combo_items: list_item_combo,
    product_id: item.product_id || null,
    product_variant_id: item.product_variant_id || null,
    product_variant_name: item.product_combo_id ? null : item.item_variant_name,
    qty: item.qty,
    sell_price: item.price,
    stock_qty: item.stock_qty || 0,
    sub_total: item.amount,
    track_inventory: item.track_inventory || 0
  }
}

export async function validateStockMaterial(items) {
  try {
    await validateMaterial({ item: items })
    return true
  } catch (e) {
    Object.assign(store.state, {
      show_error: true,
      error_message: e.message,
      error_type: 402
    })
    return false
  }
}
